import React, { FC } from "react";
import { GetRechnungDetailsDto } from "../../../../../api-client";
import PayRechnungDialog from "../../../../pages/PatientBills/dialogs/PayBankTransferDialog";
import { DeleteConfirmationDialog } from "../../../Insurance/DirectBilling/common/exports";
import CashCancellationDialog from "../dialogs/CashCancellationDialog";

interface TransactionDialogsProps {
  // Dialog states
  cancelCashDialogOpen: boolean;
  cancelECDialogOpen: boolean;
  cancelBankTransferDialogOpen: boolean;
  deleteDialogOpen: boolean;
  payDialogOpen: boolean;

  // Data
  selectedRechnung: GetRechnungDetailsDto | null;
  deleteRechnung: GetRechnungDetailsDto | null;
  userId: string | null;

  // Handlers
  onCancelCash: (reason: string) => void;
  onCancelEC: (reason: string) => void;
  onCancelBankTransfer: (reason: string) => void;
  onDeleteRechnung: () => void;
  onPaymentSuccess: () => void;

  // Close handlers
  onCloseCancelCash: () => void;
  onCloseCancelEC: () => void;
  onCloseCancelBankTransfer: () => void;
  onCloseDeleteRechnung: () => void;
  onClosePayment: () => void;
}

/**
 * Consolidated dialog component
 * Implements SRP by handling all dialog rendering in one place
 * Improves code organization and reduces clutter in main component
 */
export const TransactionDialogs: FC<TransactionDialogsProps> = ({
  // States
  cancelCashDialogOpen,
  cancelECDialogOpen,
  cancelBankTransferDialogOpen,
  deleteDialogOpen,
  payDialogOpen,

  // Data
  selectedRechnung,
  userId,

  // Handlers
  onCancelCash,
  onCancelEC,
  onCancelBankTransfer,
  onDeleteRechnung,
  onPaymentSuccess,

  // Close handlers
  onCloseCancelCash,
  onCloseCancelEC,
  onCloseCancelBankTransfer,
  onCloseDeleteRechnung,
  onClosePayment,
}) => {
  return (
    <>
      {/* Payment Dialog for Rechnung */}
      <PayRechnungDialog
        open={payDialogOpen}
        onClose={onClosePayment}
        rechnung={selectedRechnung}
        accountId={selectedRechnung?.accountId || ""}
        userId={userId || ""}
        onPaymentSuccess={onPaymentSuccess}
      />

      {/* Delete Rechnung Confirmation Dialog */}
      <DeleteConfirmationDialog
        open={deleteDialogOpen}
        onCancel={onCloseDeleteRechnung}
        onConfirm={onDeleteRechnung}
        title="Rechnung löschen?"
        content="Möchten Sie diese Rechnung wirklich löschen? Der Vorgang kann rückgängig gemacht werden."
      />

      {/* Cancel Cash Transaction Dialog */}
      <CashCancellationDialog
        open={cancelCashDialogOpen}
        onCancel={onCloseCancelCash}
        onConfirm={onCancelCash}
        title="Bargeldtransaktion stornieren?"
        content="Möchten Sie diese Bargeldtransaktion wirklich stornieren?"
      />

      {/* Cancel EC Transaction Dialog */}
      <CashCancellationDialog
        open={cancelECDialogOpen}
        onCancel={onCloseCancelEC}
        onConfirm={onCancelEC}
        title="EC-Transaktion stornieren?"
        content="Möchten Sie diese EC-Transaktion wirklich stornieren?"
      />

      {/* Cancel Bank Transfer Dialog */}
      <CashCancellationDialog
        open={cancelBankTransferDialogOpen}
        onCancel={onCloseCancelBankTransfer}
        onConfirm={onCancelBankTransfer}
        title="Überweisung stornieren?"
        content="Möchten Sie diese Überweisung wirklich stornieren? Die Zuordnungen zu den Rechnungen werden rückgängig gemacht."
      />
    </>
  );
};
